import WorkflowRunHistory from './WorkflowRunHistory.Container';

export default WorkflowRunHistory;
